import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { RfhColors } from '../config/florimixColors'
import { useTranslation } from 'react-i18next'

type BusinessAssociationBannerProps = {
  businessAssociationName: string | undefined
  isOwnUse?: boolean
}

export const BusinessAssociationBanner = ({
  businessAssociationName,
  isOwnUse = false,
}: BusinessAssociationBannerProps) => {
  const { t } = useTranslation()

  if (!businessAssociationName) {
    return null
  }

  return (
    <Box
      data-testid='business-association-banner'
      sx={{
        display: { xs: 'flex', md: 'none' },
        flexDirection: 'row',
        gap: 0.5,
        backgroundColor: '#F2F2F2',
        py: theme => theme.spacing(1),
        px: theme => theme.spacing(2),
        position: 'sticky',
        top: theme => theme.spacing(9.25),
        zIndex: theme => theme.zIndex.appBar - 1,
      }}
    >
      <Typography
        variant='body1'
        sx={{ fontWeight: 700, color: RfhColors.darkGrey }}
      >
        {t(
          isOwnUse
            ? 'businessAssociationBanner.ownUse'
            : 'businessAssociationBanner.workingFor'
        )}
      </Typography>
      <Typography variant='body1' sx={{ fontWeight: 700 }}>
        {businessAssociationName}
      </Typography>
    </Box>
  )
}
